import * as React from 'react';
import { FILE_NAME, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { Form, Input } from 'antd';
const { MAX: max, MESSAGE: message } = FILE_NAME;
export const FileInput = ({ disabled }) => React.createElement(Form.Item, { name: 'name', rules: [
        {
            max,
            message
        }
    ] },
    React.createElement(Input, { autoFocus: true, disabled: disabled, placeholder: PLACEHOLDERS_COPY.FILE_NAME, type: 'text' }));
